module.exports = __webpack_public_path__ + "img/tracker_schema.de0ea87f.png";